import React, {Component} from 'react';
import ReactDOM from 'react-dom';

import Left from './components/left/left';
import Download from './components/download/download';
import Ques from './components/quesition/ques';
import Help from './components/ot/ot';
import Footer from './components/footer/footer';


import './public/public.scss';

const  App = function (){
    return (
        <div className="main">
            <div className="sdk_header"></div>
            <div className="c">
                <Left />
                <div className="l rightcontaions">
                    <Download />
                    <Help />
                    <Ques />
                </div>
            </div>

            <Footer />
        </div>
    )
};

ReactDOM.render(<App />, document.getElementById('root'));




// WEBPACK FOOTER //
// ./D:/front-end-svn/webpack/src/project/sdk/index.jsx